export default {
  container: {
    overflowY: 'auto',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'white',
    marginLeft: '5%',
    height: 'calc(94vh - 115px)',
    alignItems: 'center',
  },

  containerMobile: {
    height: 'calc(94vh - 115px)',
    backgroundColor: 'white',
    display: 'flex',
    justifyContent: 'center',
  },

  headingText: {
    textAlign: 'center',
  },
};



// WEBPACK FOOTER //
// ./src/Pages/NoAccess/styles.js